import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import constants from 'src/config/constants';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private timeoutId: any;
  private readonly activityEvents = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];
  private readonly timer$ = new Subject<void>();
  private readonly boundReset: () => void;

  constructor(private router: Router, private ngZone: NgZone) {
    this.boundReset = this.resetTimer.bind(this);
  }

  private setupListeners() {
    this.ngZone.runOutsideAngular(() => {
      this.activityEvents.forEach(event =>
        document.addEventListener(event, this.boundReset)
      );
    });
  }

  private resetTimer() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.ngZone.run(() => this.onTimeout());
    }, constants.inactivityLogoutTimeoutMs);
  }

  private onTimeout() {
    this.timer$.next();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.router.navigate(['/auth/login'], {
      queryParams: { reason: 'sessionExpired' }
    });
  }

  public stopMonitoring() {
    this.activityEvents.forEach(event =>
      document.removeEventListener(event, this.boundReset)
    );
    clearTimeout(this.timeoutId);
  }

  public startMonitoring() {
    this.resetTimer();
    this.setupListeners();
  }

  public get idleTimeout$() {
    return this.timer$.asObservable();
  }
}
